import React from "react";
import type { Announcement } from "../types";

interface Props {
  items: Announcement[];
  onClose: () => void;
}

export default function AnnouncementModal({ items, onClose }: Props) {
  if (items.length === 0) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/55 p-4 md:p-8">
      <div className="surface-panel relative w-full max-w-4xl overflow-hidden rounded-[1.8rem]">
        <button
          type="button"
          aria-label="Close announcements"
          onClick={onClose}
          className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-xl text-slate-600 shadow-sm hover:bg-slate-50"
        >
          x
        </button>

        <div className="border-b border-slate-200/70 px-6 py-5 md:px-8">
          <div className="eyebrow">Welcome</div>
          <h2 className="mt-2 text-3xl font-semibold tracking-tight text-slate-950">Announcements</h2>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Review current reminders and updates before moving into the workspace.
          </p>
        </div>

        <div className="max-h-[70vh] overflow-y-auto px-6 py-6 md:px-8">
          <div className="space-y-4">
            {items.map((announcement) => (
              <article key={announcement.id} className="surface-muted p-5">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <h3 className="text-xl font-semibold tracking-tight text-slate-950">{announcement.title}</h3>
                  <div className="flex items-center gap-2">
                    <span className="badge-pill bg-amber-100 text-amber-800">
                      Priority {announcement.priority}
                    </span>
                    <span className="text-xs text-slate-500">
                      {new Date(announcement.created_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
                <div
                  className="mt-3 text-sm leading-7 text-slate-700"
                  dangerouslySetInnerHTML={{ __html: announcement.content }}
                />
              </article>
            ))}
          </div>
        </div>

        <div className="flex justify-end border-t border-slate-200/70 px-6 py-4 md:px-8">
          <button type="button" onClick={onClose} className="button-primary">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
